export const AGENCY_DASHBOARD_BASE_PATH = '/agency/dashboard';
